<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputBasic
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "../../../inputs/InputBasic";

export default {
  name: 'AmountPets',
  components: {
    InputBasic,
    QuestionBase
  },
  mixins: [questionLoadHelpers],
  props: {
    value: {
      type: String,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {

      question: {
        title:  'How much would you like to leave?',
        subTitle:  'Consider that over their lifetime, the average cost of owning a pet is around £16,000 for a dog or cat. Depending on the food you buy and sudden medical expenses, the costs could be much higher.',
        tip: null
      },
      db: {
        saveLocation: 'product_will_data',
        saveField: 'amountPets',
        formPath: 'data.pets.details.cash.amount',
        jsonSaveField: 'amount'
      },
      args: {
        placeholder: 'e.g. £20,000',
        label: null,
        type: 'text',
        skippable: false,
        required: true,
        inputClass: 'field-66'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>